import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.prototype.$axios = axios
Vue.config.productionTip = false

if (process.env.NODE_ENV === "development") {
  // Vue.prototype.url = '/api'
    console.log('development')
}
if (process.env.NODE_ENV === "test") {
	// Vue.prototype.url = '/api2'
    console.log('test')
}
if (process.env.NODE_ENV === "production") {
	// Vue.prototype.url = '/api3'
    console.log('production')

}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
